import { Routes, Route, Link, useLocation } from 'react-router-dom'
import { FileText, MessageCircle, BarChart3, Upload } from 'lucide-react'
import HomePage from './pages/HomePage'
import TranslatePage from './pages/TranslatePage'
import ChatPage from './pages/ChatPage'
import DashboardPage from './pages/DashboardPage'
import { OfflineIndicator, OfflineBanner, InstallPrompt, ConnectionStatus } from './components/offline'
import { UpdatePrompt } from './components/offline'

const NAV_ITEMS = [
  { path: '/', label: 'Upload', icon: Upload },
  { path: '/dashboard', label: 'Dashboard', icon: BarChart3 },
]

function App() {
  const location = useLocation()

  return (
    <div className="min-h-screen flex flex-col">
      {/* Offline Banner */}
      <OfflineBanner />

      {/* Header */}
      <header className="bg-navy text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-90">
            <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center">
              <FileText className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold leading-tight">MedTranslate</h1>
              <p className="text-xs text-gray-300">Clinical Trial Accessibility</p>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <ConnectionStatus className="hidden sm:flex" />
            <nav className="flex gap-2">
              {NAV_ITEMS.map(({ path, label, icon: Icon }) => (
                <Link
                  key={path}
                  to={path}
                  className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-colors
                    ${location.pathname === path
                      ? 'bg-primary text-white'
                      : 'text-gray-300 hover:bg-navy-light hover:text-white'
                    }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="hidden sm:inline">{label}</span>
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/translate/:documentId" element={<TranslatePage />} />
          <Route path="/chat/:documentId" element={<ChatPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 py-4 px-4">
        <div className="max-w-7xl mx-auto text-center text-sm text-gray-500">
          <p>
            This tool provides simplified explanations of clinical trial documents.
            It is <strong>not</strong> medical advice. Always consult the study team or your doctor.
          </p>
        </div>
      </footer>

      {/* PWA Components */}
      <OfflineIndicator />
      <InstallPrompt />
      <UpdatePrompt />
    </div>
  )
}

export default App
